import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const changeVersion = async (key, version, method) => {
   return axios({
      method: method,
      url: `${hostCloud}/version-registry?key=${key}&version=${version}`,
      headers: {
         Accept: "*/*"
      }
   });
};
